(function(angular) {
    'use strict';

    angular.module('aprima-provider-api').factory('ListService', [
        '_',
        '$q',
        'AprimaAnalytics',
        'AprimaCache',
        'ListRepository',
        'MessageTypes',
        'RequestTypes',
        ListService
    ]);

    // Don't port this to Angular since its interface is too generic and magic.
    // As callers are ported to Angular, they should be calling individual typed methods on the Angular ListService.
    function ListService(
        _,
        $q,
        AprimaAnalytics,
        AprimaCache,
        ListRepository,
        MessageTypes,
        RequestTypes
    ) {

        var medicationsListTypeRegex = /^medications-/i;
        var defaultCache;

        var service = {
            getList: getList,
            getLists: getLists,
        };

        return service;

        function getDefaultCache() {
            if (!defaultCache) {
                defaultCache = AprimaCache.Lists;
            }

            return defaultCache;
        }

        // listType can be
        // string: 'listName'
        // or
        // object: { name: 'listName', params: { query: 'something'}}
        function getList(listType, $scope, scopeProperty, applicationComponent) {
            var queryListType = listType && listType.name || listType;
            var listParams = listType && listType.params;
            var promise;
            var timing = AprimaAnalytics.startTiming(applicationComponent || 'ListService', 'api', 'getList-' + queryListType);
            var responseListType;

            if(medicationsListTypeRegex.test(queryListType)) {
                responseListType = queryListType.replace(medicationsListTypeRegex, '');
                queryListType = 'medications/' + responseListType;
            } else {
                responseListType = queryListType.split('/')[0];
            }

            promise = internalGetList(queryListType, listParams)
                .then(function (list) {
                    var plainList = list && list.plain ? list.plain() : list;

                    return plainList;
                }, function(response) {
                    response.listType = responseListType;
                    return $q.reject(response);
                });

            if($scope && scopeProperty) {
                promise = promise.then(function(list){
                    $scope[scopeProperty] = list;
                    return list;
                });
            }

            return promise.finally(timing.stop);
        }

        //==============================================================================
        //Structure of lists as an Object:
        // {scopeProperty1: 'listType1', scopeProperty2: 'listType2', scopeProperty3: 'listType3'}
        //Returns promise that resolves to
        // {scopeProperty1: [list1], scopeProperty2: [list2], scopeProperty3: [list3]}
        //==============================================================================
        //Structure of lists as an Array:
        // ['listType1', 'listType2', 'listType3']
        //Returns promise that resolves to
        // [[list1], [list2], [list3]]
        function getLists(lists, $scope, applicationComponent) {
            var mappingFn = _.isArray(lists) ? _.map : _.mapValues;

            var listPromises = mappingFn(lists, function(listType, scopeProperty) {
                return getList(listType, $scope, scopeProperty, applicationComponent);
            });

            var allPromises = $q.all(listPromises);

            if($scope) {
                allPromises = allPromises
                    .then(function(data) {
                        $scope.removeHttpError(RequestTypes.listData);
                        return data;
                    }, function(response) {
                        var message = {};
                        message['is' + response.status] = response.listType;
                        $scope.addHttpError(response, message, RequestTypes.listData);
                        return $q.reject(response);
                    });
            }

            return allPromises;
        }

        function internalGetList(listName, listParams) {
            if (listName === 'appointmentduration') {
                //these are not defined in the database
                var durations = getAppointmentDurations();
                return $q.when(durations);
            }
            else if(listName === 'messagetypessupportedforcreate') {
                return getMessageTypesSupportedForCreate();
            }

            var promise = ListRepository.getListJs(listName, listParams, getDefaultCache());
            return $q.when(promise);
        }

        function getAppointmentDurations() {
            var defaultDurationList = [
                getMinutesDurationObject(10),
                getMinutesDurationObject(15),
                getMinutesDurationObject(20),
                getMinutesDurationObject(30),
                getMinutesDurationObject(45),
                getMinutesDurationObject(60),

                getHoursDurationObject(2),
                getHoursDurationObject(3),
                getHoursDurationObject(4),
                getHoursDurationObject(8)
            ];

            return defaultDurationList;
        }

        function getMinutesDurationObject(minutes, prefix, suffix) {
            var opts = _.defaults({
                minutes: minutes,
                prefix: prefix,
                suffix: suffix
            }, {
                prefix: minutes,
                suffix: 'minutes'
            });


            return {
                Id: minutes,
                Description: opts.prefix + ' ' + opts.suffix
            };
        }

        function getHoursDurationObject(hours) {
            return getMinutesDurationObject(hours * 60, hours, 'hours');
        }

        function getMessageTypesSupportedForCreate() {
            return $q.all([internalGetList('messagetypes', null), internalGetList('messagesubtypes', null)])
                .then(function(lists){
                    var types,subTypes, allTypes;

                    var supportedTypes = MessageTypes.SupportedMessageTypesForCreate.Types,
                        supportedSubTypes = MessageTypes.SupportedMessageTypesForCreate.SubTypes;

                    types = _(lists[0]).filter(function (t) {
                        return (_.findIndex(supportedTypes, {id: t.Id}) >= 0);
                    }).map(function(t) {
                        return {
                            messageTypeId: t.Id,
                            messageSubTypeId: null,
                            name: t.Name,
                            requiredFeature: _.find(supportedTypes, {id: t.Id}).requiredFeature
                        };
                    }).value();

                    subTypes = _(lists[1]).filter(function (t) {
                        return (_.findIndex(supportedSubTypes, {id: t.Id}) >= 0);
                    }).map(function(t) {
                        return {
                            messageTypeId: t.MessageTypeId,
                            messageSubTypeId: t.Id,
                            name: t.Name,
                            requiredFeature: _.find(supportedSubTypes, {id: t.Id}).requiredFeature
                        };
                    }).value();

                    allTypes = _(_.union(types, subTypes)).sortBy('name').value();

                    return allTypes;
                });
        }
    }

})(window.angular);
